// @flow

import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';

import { type DispatchType, type GetStateType, type ApiType } from 'types/redux';
import type { SessionAttributesType } from 'types/sessions';

export const postSessionCreateRequest = createAction<'POST_SESSION_CREATE_REQUEST', any>(
  'POST_SESSION_CREATE_REQUEST',
);
export const postSessionCreateSuccess = createAction<'POST_SESSION_CREATE_SUCCESS', any>(
  'POST_SESSION_CREATE_SUCCESS',
);
export const postSessionCreateFailure = createAction<'POST_SESSION_CREATE_FAILURE', any>(
  'POST_SESSION_CREATE_FAILURE',
);

export const putSessionReportRequest = createAction<'PUT_SESSION_REPORT_REQUEST', any>(
  'PUT_SESSION_REPORT_REQUEST',
);
export const putSessionReportSuccess = createAction<'PUT_SESSION_REPORT_SUCCESS', any>(
  'PUT_SESSION_REPORT_SUCCESS',
);
export const putSessionReportFailure = createAction<'PUT_SESSION_REPORT_FAILURE', any>(
  'PUT_SESSION_REPORT_FAILURE',
);

export const putSessionCancelRequest = createAction<'PUT_SESSION_CANCEL_REQUEST', any>(
  'PUT_SESSION_CANCEL_REQUEST',
);
export const putSessionCancelSuccess = createAction<'PUT_SESSION_CANCEL_SUCCESS', any>(
  'PUT_SESSION_CANCEL_SUCCESS',
);
export const putSessionCancelFailure = createAction<'PUT_SESSION_CANCEL_FAILURE', any>(
  'PUT_SESSION_CANCEL_FAILURE',
);

export const putSessionDeleteRequest = createAction<'PUT_SESSION_DELETE_REQUEST', any>(
  'PUT_SESSION_DELETE_REQUEST',
);
export const putSessionDeleteSuccess = createAction<'PUT_SESSION_DELETE_SUCCESS', any>(
  'PUT_SESSION_DELETE_SUCCESS',
);
export const putSessionDeleteFailure = createAction<'PUT_SESSION_DELETE_FAILURE', any>(
  'PUT_SESSION_DELETE_FAILURE',
);

export const putSessionUpdateRequest = createAction<'PUT_SESSION_UPDATE_REQUEST', any>(
  'PUT_SESSION_UPDATE_REQUEST',
);
export const putSessionUpdateSuccess = createAction<'PUT_SESSION_UPDATE_SUCCESS', any>(
  'PUT_SESSION_UPDATE_SUCCESS',
);
export const putSessionUpdateFailure = createAction<'PUT_SESSION_UPDATE_FAILURE', any>(
  'PUT_SESSION_UPDATE_FAILURE',
);

export const postSessionCreate = (
  attributes: $Shape<{ ...SessionAttributesType, sessionRecurrenceCount: ?number }>,
) => async (dispatch: DispatchType, getState: GetStateType, api: ApiType): Promise<any> => {
  dispatch(postSessionCreateRequest());
  const data: {
    data: {
      type: 'sessions',
      attributes: $Shape<{ ...SessionAttributesType, sessionRecurrenceCount: ?number }>,
    },
  } = { data: { type: 'sessions', attributes } };
  try {
    const response = await api.postSessionCreate(data);
    api.checkStatus(response);
    dispatch(postSessionCreateSuccess(response.sessions));
    dispatch(push('/sessions'));
  } catch (error) {
    dispatch(postSessionCreateFailure(error));
  }
};

export const putSessionReport = (
  sessionId: string,
  attributes: $Shape<SessionAttributesType>,
) => async (dispatch: DispatchType, getState: GetStateType, api: ApiType): Promise<any> => {
  dispatch(putSessionReportRequest());
  const data = {
    data: {
      attributes,
      id: sessionId,
      type: 'sessions',
    },
  };
  try {
    const response = await api.putSession(sessionId, data);
    api.checkStatus(response);
    dispatch(putSessionReportSuccess(response.sessions));
    dispatch(push('/sessions'));
  } catch (error) {
    dispatch(putSessionReportFailure(error));
  }
};

export const cancelSession = (sessionId: string) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
): Promise<any> => {
  dispatch(putSessionCancelRequest());
  const data = {
    data: {
      id: sessionId,
      type: 'sessions',
      attributes: { status: 'canceled' },
    },
  };
  try {
    const response = await api.putSession(sessionId, data);
    api.checkStatus(response);
    dispatch(push('/sessions'));
    dispatch(putSessionCancelSuccess(response.sessions));
  } catch (error) {
    dispatch(putSessionCancelFailure(error));
  }
};

export const deleteSession = (sessionId: string, shouldUpdateFutureSessions: boolean) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
): Promise<any> => {
  dispatch(putSessionDeleteRequest());
  const data = {
    data: {
      id: sessionId,
      type: 'sessions',
      attributes: { status: 'deleted', shouldUpdateFutureSessions },
    },
  };
  try {
    const response = await api.putSession(sessionId, data);
    api.checkStatus(response);
    dispatch(push('/sessions'));
    dispatch(putSessionDeleteSuccess(response.sessions));
  } catch (error) {
    dispatch(putSessionDeleteFailure(error));
  }
};

export const putSessionUpdate = (
  sessionId: string,
  attributes: $Shape<SessionAttributesType>,
) => async (dispatch: DispatchType, getState: GetStateType, api: ApiType): Promise<any> => {
  dispatch(putSessionUpdateRequest());
  const data = { data: { id: sessionId, type: 'sessions', attributes } };
  try {
    const response = await api.putSession(sessionId, data);
    api.checkStatus(response);
    dispatch(putSessionUpdateSuccess(response.sessions));
    dispatch(push(`/sessions/${sessionId}`));
  } catch (error) {
    dispatch(putSessionUpdateFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/actions/sessions/index.js